export enum Platform {
    Website = 'Website',
    MobileApp = 'MobileApp',
    MobileAppAndroid = 'MobileAppAndroid',
    MobileAppIOS = 'MobileAppIOS',
}
